import React, { useCallback, useEffect, useState } from 'react';

import { usePatientDocumentContext } from '../../contexts/PatientDocument';
import { usePatientFormContext } from "../../contexts/PatientForm";
import { DocumentInputField } from './DocumentInputField'

function DocumentInputFieldContainer({ onSubmit, loading }) {
	const [ passCode, setPassCode ] = useState('');
	const [ isPassport, setIsPassport] = useState('');

	const { document } = usePatientDocumentContext();
	const { form } = usePatientFormContext();

	useEffect(() => {
		if (!document && !form) {
			return;
		}

		const type = document?.document_type || form?.type;
		const isPassport = type === 'FOREIGN_PASSPORT';

		setIsPassport(isPassport);
		setPassCode(passCode)
	}, [document, form, passCode]);

	const handleInputChange = useCallback(event => {
		const { value } = event.target;

		setPassCode(value?.toUpperCase());
	}, []);

	const handleSubmit = useCallback(event => {
		onSubmit(passCode);
	}, [passCode, onSubmit]);

	return (
		<DocumentInputField
			value={passCode}
			loading={loading}
			Submit={handleSubmit}
			isPassport={isPassport}
			onChangePassCode={handleInputChange}
		/>
	);
}

export default DocumentInputFieldContainer;
